import { Component, inject } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';
import { SharedModule } from '../../../shared/shared.module';
import { trigger, state, style, animate, transition} from '@angular/animations';

@Component({
  selector: 'ngb-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  imports:[
    SharedModule
  ],
  animations: [
    trigger('fadeIn', [
      state('true', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate(300)]),
      transition(':leave', animate(200, style({ opacity: 0 })))
    ])
  ]
})
export class SpinnerComponent {
  private readonly _spinnerService: SpinnerService = inject(SpinnerService);

  get loading(): boolean {
    return this._spinnerService.loading;
  }
}


